import React from 'react';
import proptypes from 'prop-types';
const { string } = proptypes;

export const Symbol = ({ symbol }) => {

  return (
    // eslint-disable-next-line @harmony/stencil/no-tailwind-disable
    // eslint-disable-next-line tailwindcss/no-arbitrary-value
    <div className="sui-font-bold sui-text-8xl sui-leading-[4rem]">
      {symbol}
    </div>
  );
};

Symbol.propTypes = {
  symbol: string.isRequired
};